export default "<div class=\"loading\">\n  <img src=\"../../../assets/loading.svg\" alt=\"Loading...\" />\n</div>\n"